import React from 'react';
import classnames from 'classnames';
import { observer } from 'mobx-react';

import style from './Checkbox.module.scss';

import CheckIcon from '@components/Icon/svg/check_redesign.svg';

export enum CheckboxType {
    // @ts-ignore
    Large = style.large,
    // @ts-ignore
    Small = style.small,
}

export enum CheckboxModifiers {
    // @ts-ignore
    AlignTop = style.alignTop,
}

export interface CheckboxProps {
    isChecked: boolean;
    disabled?: boolean;
    label?: string;
    name?: string;
    value?: string | number;
    dataTest?: string;
    type?: CheckboxType;
    modifiers?: CheckboxModifiers[];
    onChange(event: React.ChangeEvent<HTMLInputElement>, checked?: boolean): void;
}

export const Checkbox = observer(
    ({
        isChecked,
        onChange,
        disabled,
        value,
        name,
        label,
        dataTest,
        type = CheckboxType.Large,
        modifiers = [],
    }: CheckboxProps) => {
        return (
            <label
                className={classnames(style.container, type, disabled && style.disabled, ...modifiers)}
                data-role="checkbox"
            >
                <input
                    type="checkbox"
                    data-test={dataTest || `checkbox_${value}`}
                    data-testid={dataTest || `checkbox_${value}`}
                    value={value}
                    name={name}
                    checked={isChecked}
                    onChange={onChange}
                    disabled={disabled}
                />
                <span className={style.iconWrapper}>
                    {isChecked && (
                        <div className={style.checkedIconWrapper}>
                            <CheckIcon />
                        </div>
                    )}
                </span>
                {label && <div className={style.label}>{label}</div>}
            </label>
        );
    },
);
